import React from 'react'
import { TableCell } from '@mui/material'
import moment from 'moment'

export function AnalyticsTableItems({ item }) {
    return (
        <>
            <TableCell>
                {item.appSource}
            </TableCell>
            <TableCell>
                {item.appVersionCode}
            </TableCell>
            <TableCell>
                {item.appVersionName}
            </TableCell>
            <TableCell>
                {item.attendanceMobileId}
            </TableCell>
            <TableCell>
                {item.compScore}
            </TableCell>
            <TableCell>
                {moment(item.createdAt).format('YYYY-MM-DD HH:mm')}
            </TableCell>
            <TableCell>
                {item.detail}
            </TableCell>
            <TableCell>
                {item.deviceId}
            </TableCell>
            <TableCell>
                {item.deviceModel}
            </TableCell>
            <TableCell>
                {item.deviceName}
            </TableCell>
            <TableCell>
                {item.identityId}
            </TableCell>
            <TableCell>
                {item.initialImageHash}
            </TableCell>
            <TableCell>
                {item.lastImageHash}
            </TableCell>
            <TableCell>
                {item.lat}
            </TableCell>
            <TableCell>
                {item.lon}
            </TableCell>
            <TableCell>
                {item.packageId}
            </TableCell>
            <TableCell>
                {item.statusCode}
            </TableCell>
            <TableCell>
                {item.tenantEntityId}
            </TableCell>
            <TableCell>
                {item.timestamp}
            </TableCell>
            <TableCell>
                {item.trustedTimestamp}
            </TableCell>
            <TableCell>
                {item.xSignature}
            </TableCell>

        </>
    )
}
